import {
	bestSentiment,
	companyCategory,
	companyCountry,
	country,
	lastContactAt,
	listFilter,
	overallScore,
	personaCategory,
	sentimentValues,
} from "@/pages/Private/pages/Contacts/constants/contacts-filter";

/**
 * Filter-param + filter-name pairs for every curated re-engagement criterion. The `name` is used
 * as the key inside the stored IFilterWithValues object and as the `propertyName` when fetching
 * dropdown options through `getFilterByProperty`. The `param` is the SQL column the backend
 * filters on.
 */
export const REENGAGE_FIELDS = {
	fromList: { name: listFilter.name, param: listFilter.filterParam },
	bestSentiment: { name: bestSentiment.name, param: bestSentiment.filterParam },
	lastContact: { name: lastContactAt.name, param: lastContactAt.filterParam },
	companyCategory: { name: companyCategory.name, param: companyCategory.filterParam },
	personaCategory: { name: personaCategory.name, param: personaCategory.filterParam },
	leadScore: { name: overallScore.name, param: overallScore.filterParam },
	companyHqLocation: { name: companyCountry.name, param: companyCountry.filterParam },
	personalLocation: { name: country.name, param: country.filterParam },
} as const;

/** Best-sentiment options, reused from the Contacts filter definitions ({ value, label }). */
export const SENTIMENT_OPTIONS = sentimentValues.map((s) => ({ id: s.value, title: s.label }));

/**
 * Last-contact presets. `days` drives the relative `lessEqualDate` offset so the value
 * round-trips exactly: the backend stores `relativeDays = -days`, which we map straight back
 * to the preset on load.
 */
export type LastContactPreset = "1m" | "2m" | "3m" | "6m" | "custom";

export const LAST_CONTACT_OPTIONS: { id: LastContactPreset; days: number | null }[] = [
	{ id: "1m", days: 30 },
	{ id: "2m", days: 60 },
	{ id: "3m", days: 90 },
	{ id: "6m", days: 180 },
	{ id: "custom", days: null },
];

export const DEFAULT_LAST_CONTACT: LastContactPreset = "3m";

/** Lead-scoring buckets shown in the curated form. */
export const LEAD_SCORE_OPTIONS = [
	{ id: "P1", title: "P1" },
	{ id: "P2", title: "P2" },
	{ id: "P3", title: "P3" },
	{ id: "DQ", title: "DQ" },
];
